import {
  SET_LABELER_ID,
  SET_REVIEWER_ID,
  FETCH_USER_IN_PROJECT,
  FETCH_USER_IN_PROJECT_SUCCESS,
} from "./constants";

export function setLabelerId(payload) {
  return {
    type: SET_LABELER_ID,
    payload,
  };
}

export function setReviewerId(payload) {
  return {
    type: SET_REVIEWER_ID,
    payload,
  };
}

export function fetchUserInProject(payload) {
  return {
    type: FETCH_USER_IN_PROJECT,
    payload,
  };
}

export function fetchUserInProjectSuccess(payload) {
  return {
    type: FETCH_USER_IN_PROJECT_SUCCESS,
    payload,
  };
}
